import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';

export const selectBeadlConfig = (state: RootState) => state.beadl;

export const beadlSelector = createSelector(selectBeadlConfig, (state) => state);
